import { Routes, Route, Link, useLocation } from "react-router-dom";
import HeaderOne from "../../../HeaderOne";
import Breadcrumb from "../../../Breadcrumb";
import FooterOne from "../../../FooterOne";

import ListOrders from "./ListOrders";
import ViewOrder from "./ViewOrder";
import TrackOrder from "./TrackOrder";
import ReturnReplace from "./CancelOrder";
import Invoice from "./Invoice";

const Orders = () => {
  const location = useLocation();
  const isActive = (path) => location.pathname.includes(path);

  return (
    <>
      <style>{`
        .orders-main-container {
          min-height: 100vh;
          background: #f9fafb;
        }

        .orders-wrapper {
          max-width: 1400px;
          margin: 0 auto;
          padding: 2rem 1rem;
        }

        .orders-header-section {
          margin-bottom: 2rem;
          padding: 0 0 1.5rem 0;
          border-bottom: 2px solid #f3f4f6;
        }

        .orders-header-section h1 {
          font-size: 2rem;
          font-weight: 600;
          margin: 0 0 0.5rem 0;
          color: #111827;
        }

        .orders-header-section p {
          font-size: 1rem;
          color: #6b7280;
          margin: 0;
        }

        .orders-nav {
          display: flex;
          gap: 1rem;
          margin-bottom: 2rem;
          background: white;
          padding: 1rem;
          border-radius: 12px;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
          overflow-x: auto;
        }

        .orders-nav::-webkit-scrollbar {
          height: 4px;
        }

        .orders-nav::-webkit-scrollbar-thumb {
          background: #d1d5db;
          border-radius: 4px;
        }

        .orders-tab {
          padding: 0.75rem 1.5rem;
          border-radius: 8px;
          text-decoration: none;
          color: #6b7280;
          font-weight: 500;
          transition: all 0.3s ease;
          white-space: nowrap;
          border: 2px solid transparent;
        }

        .orders-tab:hover {
          background: #f3f4f6;
          color: #111827;
        }

        .orders-tab.active {
          background: #3b82f6;
          color: white;
          border-color: #3b82f6;
          box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
        }

        .orders-content {
          background: white;
          border-radius: 12px;
          padding: 2rem;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
          min-height: 400px;
        }

        @media (max-width: 768px) {
          .orders-wrapper {
            padding: 1rem 0.5rem;
          }

          .orders-header-section {
            padding: 1.5rem 1rem;
            border-radius: 12px;
            margin: 0 0.5rem 1.5rem 0.5rem;
          }

          .orders-header-section h1 {
            font-size: 1.75rem;
          }

          .orders-header-section p {
            font-size: 0.95rem;
          }

          .orders-nav {
            margin: 0 0.5rem 1.5rem 0.5rem;
            padding: 0.75rem;
          }

          .orders-tab {
            padding: 0.6rem 1.2rem;
            font-size: 0.9rem;
          }

          .orders-content {
            margin: 0 0.5rem;
            padding: 1rem;
            border-radius: 8px;
          }
        }

        @media (max-width: 480px) {
          .orders-header-section h1 {
            font-size: 1.5rem;
          }

          .orders-tab {
            padding: 0.5rem 1rem;
            font-size: 0.85rem;
          }

          .orders-content {
            padding: 0.75rem;
          }
        }
      `}</style>

      <HeaderOne />
      <Breadcrumb />

      <div className="orders-main-container">
        <div className="orders-wrapper">
          {/* <div className="orders-header-section">
            <h1>My Orders</h1>
            <p>Track, manage and review all your orders in one place</p>
          </div> */}
          <div className="orders-content">
            <Routes>
              <Route path="/" element={<ListOrders />} />
              <Route path=":orderId/*" element={<ViewOrder />}>
                <Route path="track" element={<TrackOrder />} />
                <Route path="replace" element={<ReturnReplace />} />
                <Route path="invoice" element={<Invoice />} />
              </Route>
            </Routes>
          </div>
        </div>
      </div>

      <FooterOne />
    </>
  );
};

export default Orders;